<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Mein Profil<v-spacer></v-spacer>
        <!-- <v-btn
          v-if="!showPersonnelRecordInViewMode"
          text
          outlined
          small
          :disabled="helpers.dataIsLoading"
          :to="{
            name: 'member-management-personnel-records-details-general',
            params: {
              organizationId: $route.params.organizationId,
              itemId: currentUserUid,
            },
          }"
          >Personalakte anzeigen</v-btn
        > -->
      </v-card-title>
      <v-skeleton-loader
        v-if="helpers.dataIsLoading"
        elevation="2"
        type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
      ></v-skeleton-loader>
      <div v-else>
        <v-alert
          v-if="isBirthday"
          color="primary"
          colored-border
          icon="mdi-cake-variant"
          border="left"
          elevation="2"
          class="mb-4"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">Herzlichen Glückwunsch zum Geburtstag!</div>
              <div>Wir wünschen dir alles Gute zu deinem besonderen Tag!</div>
            </v-col>
          </v-row>
        </v-alert>
        <v-row class="match-height" dense>
          <v-col cols="12">
            <v-card>
              <!-- Stammdaten Section -->
              <v-card-title class="d-flex align-center pa-3">
                <v-icon left small>mdi-account-circle</v-icon>
                <span class="subtitle-2">Stammdaten</span>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  small
                  @click="expandedSections.profile = !expandedSections.profile"
                  class="ml-2"
                >
                  <v-icon>{{
                    expandedSections.profile
                      ? "mdi-chevron-up"
                      : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="expandedSections.profile">
                  <v-card-text class="pt-0">
                    <v-row dense>
                      <v-col cols="6">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              {{
                                generalData.salutation
                                  ? generalData.salutation
                                  : "Name"
                              }}
                            </div>
                            <div class="font-weight-medium">
                              {{ generalData.title }}
                              {{ generalData.firstName }}
                              {{ generalData.lastName }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="generalData.birthdate">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              Geburtsdatum (Alter)
                            </div>
                            <div class="font-weight-medium">
                              {{ formatDate(generalData.birthdate) }} ({{
                                getAge(generalData.birthdate)
                              }})
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="generalData.personnelNumber">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              Personalnummer
                            </div>
                            <div class="font-weight-medium">
                              <pre>{{ generalData.personnelNumber }}</pre>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="generalData.division?.title">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              Einheit/Abteilung
                            </div>
                            <div class="font-weight-medium">
                              {{ generalData.division.title }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="generalData.memberSince">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              Mitglied seit
                            </div>
                            <div class="font-weight-medium">
                              {{ formatDate(generalData.memberSince) }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="generalData.rank?.title">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              Dienstgrad
                            </div>
                            <div class="d-flex align-center">
                              <img
                                v-if="generalData.rank.badgeUrl?.size125x125"
                                :src="generalData.rank.badgeUrl.size125x125"
                                height="20px"
                                class="mr-2"
                              />
                              <span class="font-weight-medium">
                                {{
                                  $vuetify.breakpoint.smAndDown
                                    ? generalData.rank.shortTitle
                                    : generalData.rank.title
                                }}
                              </span>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="generalData.dutyPosition?.title">
                        <v-card outlined>
                          <v-card-text class="py-2">
                            <div class="text-caption grey--text mb-1">
                              Dienststellung
                            </div>
                            <div class="d-flex align-center">
                              <img
                                v-if="
                                  generalData.dutyPosition.badgeUrl?.size125x125
                                "
                                :src="
                                  generalData.dutyPosition.badgeUrl.size125x125
                                "
                                height="20px"
                                class="mr-2"
                              />
                              <span class="font-weight-medium">
                                {{
                                  $vuetify.breakpoint.smAndDown
                                    ? generalData.dutyPosition.shortTitle
                                    : generalData.dutyPosition.title
                                }}
                              </span>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <personnel-record-detail-card-assignments
                      :member="member"
                      flat
                      class="pt-4"
                    >
                      <template v-slot:header>
                        <v-card-title class="body-2 v-card__subtitle pt-0 px-0">
                          <v-icon left small class="mr-2">mdi-briefcase</v-icon>
                          Meine Aufgabengebiete
                        </v-card-title>
                      </template>
                    </personnel-record-detail-card-assignments>
                  </v-card-text>
                </div>
              </v-expand-transition>

              <v-divider></v-divider>

              <!-- Fertigkeiten Section -->
              <v-card-title class="d-flex align-center pa-3">
                <v-icon left small>mdi-certificate</v-icon>
                <span class="subtitle-2">Fertigkeiten</span>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  small
                  @click="expandedSections.skills = !expandedSections.skills"
                  class="ml-2"
                >
                  <v-icon>{{
                    expandedSections.skills
                      ? "mdi-chevron-up"
                      : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="expandedSections.skills">
                  <v-card-text class="py-0">
                    <personnel-record-detail-card-skills :member="member" flat>
                      <template v-slot:header>
                        <v-card-title class="body-2 v-card__subtitle pt-0 px-0">
                          <v-icon left small class="mr-2">mdi-label</v-icon>
                          Meine Qualifikationen (Höchste)
                        </v-card-title>
                      </template>
                    </personnel-record-detail-card-skills>
                  </v-card-text>
                  <personnel-record-detail-card-content-fillable-positions
                    :member="member"
                    flat
                    smallChips
                  ></personnel-record-detail-card-content-fillable-positions>
                </div>
              </v-expand-transition>

              <v-divider></v-divider>

              <!-- Kontaktdaten Section -->
              <div :class="{ 'v-card--disabled': !enableContactData }">
                <v-card-title class="d-flex align-center pa-3">
                  <v-icon left small>mdi-card-account-details</v-icon>
                  <span class="subtitle-2">Kontaktdaten</span>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" small depressed disabled>
                    <v-icon left small>mdi-pencil</v-icon>
                    Bearbeiten
                  </v-btn>
                  <v-btn
                    icon
                    small
                    @click="
                      expandedSections.contact = !expandedSections.contact
                    "
                    class="ml-2"
                  >
                    <v-icon>{{
                      expandedSections.contact
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </v-btn>
                </v-card-title>
                <v-expand-transition>
                  <div v-show="expandedSections.contact">
                    <v-card-text class="pa-0">
                      <personnel-record-contact-card
                        type="personal"
                        :contact="contactData.personal"
                        flat
                        cardTextClass="pt-0"
                        class="mb-n4"
                      ></personnel-record-contact-card>

                      <personnel-record-contact-card
                        type="station"
                        hideAdress
                        :contact="contactData.station"
                        flat
                        class="mb-n4"
                      ></personnel-record-contact-card>

                      <personnel-record-contact-card
                        type="business"
                        :contact="contactData.business"
                        flat
                      ></personnel-record-contact-card>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </div>

              <v-divider></v-divider>

              <!-- Notfallkontakte Section -->
              <div :class="{ 'v-card--disabled': !enableEmergencyContacts }">
                <v-card-title class="d-flex align-center pa-3">
                  <v-icon left small>mdi-phone-alert</v-icon>
                  <span class="subtitle-2">Notfallkontakte</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    small
                    depressed
                    :disabled="!enableEmergencyContacts"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    Bearbeiten
                  </v-btn>
                  <v-btn
                    icon
                    small
                    :disabled="!enableEmergencyContacts"
                    @click="
                      expandedSections.emergency = !expandedSections.emergency
                    "
                    class="ml-2"
                  >
                    <v-icon>{{
                      expandedSections.emergency
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </v-btn>
                </v-card-title>
                <v-expand-transition>
                  <div
                    v-show="
                      expandedSections.emergency && enableEmergencyContacts
                    "
                  >
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="emergencyContacts && emergencyContacts.length > 0"
                    >
                      <v-list dense>
                        <v-list-item
                          v-for="(contact, index) in emergencyContacts"
                          :key="index"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                              {{ contact.firstName }} {{ contact.lastName }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="contact.relationship">
                              {{ contact.relationship }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="contact.phone">
                              <v-icon x-small>mdi-phone</v-icon>
                              {{ contact.phone }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="contact.mobile">
                              <v-icon x-small>mdi-cellphone</v-icon>
                              {{ contact.mobile }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                    <v-card-text v-else class="text-center grey--text">
                      Keine Notfallkontakte hinterlegt
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </div>

              <v-divider></v-divider>

              <!-- Abrechnung Section -->
              <div :class="{ 'v-card--disabled': !enableBankDetails }">
                <v-card-title class="d-flex align-center pa-3">
                  <v-icon left small>mdi-bank</v-icon>
                  <span class="subtitle-2">Abrechnung</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    small
                    depressed
                    :disabled="!enableBankDetails"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    Bearbeiten
                  </v-btn>
                  <v-btn
                    icon
                    small
                    :disabled="!enableBankDetails"
                    @click="expandedSections.bank = !expandedSections.bank"
                    class="ml-2"
                  >
                    <v-icon>{{
                      expandedSections.bank
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}</v-icon>
                  </v-btn>
                </v-card-title>
                <v-expand-transition>
                  <div v-show="expandedSections.bank && enableBankDetails">
                    <v-divider></v-divider>
                    <v-card-text v-if="bankData">
                      <v-list dense>
                        <v-list-item v-if="bankData.accountHolder">
                          <v-list-item-content>
                            <v-list-item-subtitle class="text-caption"
                              >Kontoinhaber</v-list-item-subtitle
                            >
                            <v-list-item-title>{{
                              bankData.accountHolder
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="bankData.iban">
                          <v-list-item-content>
                            <v-list-item-subtitle class="text-caption"
                              >IBAN</v-list-item-subtitle
                            >
                            <v-list-item-title>{{
                              bankData.iban
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="bankData.bic">
                          <v-list-item-content>
                            <v-list-item-subtitle class="text-caption"
                              >BIC</v-list-item-subtitle
                            >
                            <v-list-item-title>{{
                              bankData.bic
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="bankData.bankName">
                          <v-list-item-content>
                            <v-list-item-subtitle class="text-caption"
                              >Bank</v-list-item-subtitle
                            >
                            <v-list-item-title>{{
                              bankData.bankName
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                    <v-card-text v-else class="text-center grey--text">
                      Keine Bankverbindung hinterlegt
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import PersonnelRecordContactCard from "@/components/member-management/personnel-records/PersonnelRecordContactCard.vue";
import PersonnelRecordDetailCardSkills from "@/components/member-management/personnel-records/PersonnelRecordDetailCardSkills.vue";
import PersonnelRecordDetailCardAssignments from "@/components/member-management/personnel-records/PersonnelRecordDetailCardAssignments.vue";
import PersonnelRecordDetailCardContentFillablePositions from "@/components/member-management/personnel-records/PersonnelRecordDetailCardContentFillablePositions.vue";
import { auth, db } from "@/firebase";
export default {
  name: "self-service-personnel-record",
  props: {
    showPersonnelRecordInViewMode: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  components: {
    PersonnelRecordContactCard,
    PersonnelRecordDetailCardSkills,
    PersonnelRecordDetailCardAssignments,
    PersonnelRecordDetailCardContentFillablePositions,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: true,
      },
      generalData: {},
      contactData: {
        personal: {},
        station: {},
        business: {},
      },
      emergencyContacts: [],
      bankData: null,
      currentUserUid: auth.currentUser ? auth.currentUser.uid : null,
      expandedSections: {
        profile: false,
        skills: false,
        contact: false,
        emergency: false,
        bank: false,
      },
      // Feature flags - set to true to enable sections
      enableEmergencyContacts: false,
      enableBankDetails: false,
      enableContactData: true,
    };
  },
  computed: {
    member() {
      return this.$store.state.organization.membership;
    },
    isBirthday() {
      if (!this.generalData?.birthdate) return false;
      const today = new Date();
      const birthdate = this.generalData.birthdate.toDate
        ? this.generalData.birthdate.toDate()
        : new Date(this.generalData.birthdate);
      return (
        today.getDate() === birthdate.getDate() &&
        today.getMonth() === birthdate.getMonth()
      );
    },
    hasBusinessContact() {
      if (!this.contactData?.business) return false;
      const business = this.contactData.business;
      return (
        business.name ||
        business.phone ||
        business.mobile ||
        business.email ||
        business.address?.street
      );
    },
    hasStationContact() {
      if (!this.contactData?.station) return false;
      const station = this.contactData.station;
      return station.phone || station.mobile || station.email;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.helpers.dataIsLoading = true;
      try {
        if (!this.currentUserUid) {
          return;
        }

        // Fetch general personnel record data
        const generalDoc = await db
          .collection("organizations")
          .doc(this.$route.params.organizationId)
          .collection("personnelRecords_general")
          .doc(this.currentUserUid)
          .get();

        if (generalDoc.exists) {
          this.generalData = generalDoc.data();
        }

        // Fetch contact data
        const contactDoc = await db
          .collection("organizations")
          .doc(this.$route.params.organizationId)
          .collection("personnelRecords_contact")
          .doc(this.currentUserUid)
          .get();

        if (contactDoc.exists) {
          this.contactData = contactDoc.data();
        }

        if (this.enableEmergencyContacts) {
          const emergencySnapshot = await db
            .collection("organizations")
            .doc(this.$route.params.organizationId)
            .collection("personnelRecords_emergencyContacts")
            .where("user.uid", "==", this.currentUserUid)
            .get();

          if (!emergencySnapshot.empty) {
            this.emergencyContacts = emergencySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
          }
        }

        if (this.enableBankDetails) {
          const bankDoc = await db
            .collection("organizations")
            .doc(this.$route.params.organizationId)
            .collection("personnelRecords_financial")
            .doc(this.currentUserUid)
            .get();

          if (bankDoc.exists) {
            this.bankData = bankDoc.data();
          }
        }
      } catch (error) {
        console.error("Error fetching personnel record data:", error);
      } finally {
        this.helpers.dataIsLoading = false;
      }
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    formatDate(timestamp) {
      if (!timestamp) return "";
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleDateString("de-DE", options);
    },
    getAge(birthdate) {
      if (!birthdate) return "";
      const today = new Date();
      const birthDate = birthdate.toDate
        ? birthdate.toDate()
        : new Date(birthdate);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    isExpired(expiryDate) {
      if (!expiryDate) return false;
      const date = expiryDate.toDate
        ? expiryDate.toDate()
        : new Date(expiryDate);
      return date < new Date();
    },
    isExpiringSoon(expiryDate) {
      if (!expiryDate) return false;
      const date = expiryDate.toDate
        ? expiryDate.toDate()
        : new Date(expiryDate);
      const threeMonthsFromNow = new Date();
      threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);
      return date < threeMonthsFromNow && date >= new Date();
    },
  },
};
</script>
